let initialized = false;

export function initGTM(gtmId: string): void {
  if (initialized) return;
  initialized = true;

  // GTM head script
  const script = document.createElement('script');
  script.textContent = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://s.linktr.it/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
  document.head.appendChild(script);

  // GTM noscript iframe
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://s.linktr.it/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}

export function trackLeadGTM(): void {
  if (initialized && window.dataLayer) {
    window.dataLayer.push({ event: 'Lead', source: 'whatsapp' });
  }
}

export function isGTMInitialized(): boolean {
  return initialized;
}

export function resetGTM(): void {
  initialized = false;
}
